import { Injectable, OnDestroy, signal, WritableSignal } from '@angular/core'

@Injectable()
export class CountDownUtil implements OnDestroy {
  private countSignal: WritableSignal<number> = signal(10)
  private finishedFn: () => void = () => {}

  private interval?: string | number | NodeJS.Timeout | undefined

  public readonly count = this.countSignal.asReadonly()

  public setCount(count: number): void {
    this.countSignal.set(count)
  }

  public start() {
    this.interval = setInterval(() => {
      if (this.countSignal() === 0) {
        this.stop()
        this.finishedFn()
        return
      }
      this.countSignal.update(c => c - 1)
    }, this.countSignal() * 100)
  }

  public stop() {
    clearInterval(this.interval)
  }

  public registerFinishedFn(Fn: () => void) {
    this.finishedFn = Fn
  }

  ngOnDestroy(): void {
    this.stop()
  }
}
